
export default {
  "m": {
    "sms_login": "Login por SMS",
    "get_vercode": "Enviar",
    "change_mobile": "Mudar o número de celular",
    "log_reg_agree": "Login/Registro significa concordar {msg_ss}",
    "old_mobile": "Número Móvel Original",
    "new_mobile": "Novo número de celular",
    "agency_reginfo_fill": "Preenchimento das informações de registro da guilda",
    "audit_res": "Resultado da Auditoria",
    "agency_name": "Nome da agência",
    "agency_name_input": "Favor digitar o nome da agência",
    "agency_name_input_note": "Nota: O nome da agência é recomendado para ser curto e fácil de lembrar, não mais do que 30 palavras",
    "agency_logo": "LOGOMARCA DO GRUPO",
    "agency_logo_unpload_note": "Favor carregar um logotipo claro de sua agência, suporte formato PNG/JPG/JPEG",
    "agency_contact_name": "Contato com a agência",
    "user_contact_name": "Favor preencher o nome da pessoa que está em contato diário com a plataforma do usuário",
    "agency_contact_phone": "Número de telefone de contato da agência",
    "agency_whatsapp": "WhatsApp do agente",
    "agency_whatsapp_contact": "Por favor, digite as informações de contato do agente da WhatsApp",
    "agency_use_lang": "Idioma do agente",
    "agency_head_ID": "ID do agente",
    "agency_ID_input": "Por favor inserir o ID do usuário do aplicativo BuzzCast para o agente que será usado para distribuir fundos mais tarde.",
    "reg_country": "País de registro",
    "inhand_ID_photo": "Identificação com foto em mãos",
    "upload_note_t": "Nota para o upload",
    "agency_self_inhand_ID": "Deve ser levado pelo próprio agente com o documento de passaporte",
    "photo_must_clearly": "O lado da frente deve mostrar claramente a pessoa e as informações reais do passaporte",
    "mian_form_country": "O principal país de origem do streamer",
    "invite_code": "Código de convite",
    "your_profile_submit_success": "Seu documento foi enviado com sucesso! vamos lidar com isso o mais rápido possível.<br>Os resultados da auditoria serão enviados para a notificação do BuzzCast APP do líder da guilda, por favor, preste atenção para verificar!",
    "your_profile_approved": "Sua submissão não foi aprovada! Razão da rejeição: \"Foto com mão não clara\".<br>Por favor preencher o formulário novamente ou contatar o assistente oficial no BuzzCastAPP para maiores informações.",
    "return_refill": "Retornar para preencher novamente",
    "success_agency": "Parabéns por sua bem sucedida entrada na plataforma, [clique em mim] e comece a trabalhar!",
    "personal_account": "Conta pessoal",
    "my_agency": "Minha agência",
    "your_agency_been_forcibly": "Sua agência foi terminada à força pela plataforma, e você não poderá mais entrar no sistema. Se você tiver alguma dúvida, entre em contato com o assistente oficial ou operação exclusiva do BuzzCastAPP.",
    "invite_live_join": "Convide streamer para juntar-se ao link da agência",
    "base_info": "Informações básicas",
    "apply_time": "Tempo de aplicação",
    "join_time": "Junte-se ao tempo",
    "cooper_status": "Status da cooperação",
    "streamer_manage": "Gerenciamento de streamer",
    "sereamer_apply": "Aprovação do streamer",
    "sereamer_nickname": "Apelido do streamer",
    "remark": "Observações",
    "no_remark": "Sem comentários",
    "add_remark": "Adicionar comentário",
    "birth": "Ano de nascimento",
    "user_status": "Status do usuário",
    "temporarily_frozen": "Temporariamente congelado",
    "permanently_frozen": "Permanentemente congelado",
    "fans_num": "Número de fãs",
    "sign_status": "Status da assinatura",
    "sign_ing": "Sob contrato",
    "sign_time": "Tempo de assinatura",
    "release_time": "Tempo de liberação",
    "live_viola_record": "Registro de violação do vivo",
    "sign_record": "Registro de assinatura",
    "current_contract_status": "Status atual do contrato",
    "termination_reason": "Razão da rescisão",
    "violation_reason": "Razão da violação",
    "violation_time": "Tempo de violação",
    "processing_result": "Resultado do processamento",
    "exported_data": "Dados exportados",
    "join_agency_apply": "Aprovação de entrar à agência",
    "audit_status": "Status de Auditoria",
    "pending_review": "Pendente",
    "pending_HQ_review": "Aguardando revisão pela sede",
    "not_approved_HQ": "Não aprovado pela sede",
    "withdrawn": "Retirado",
    "audit_trail": "Registro de Auditoria",
    "oper": "Operação",
    "other_video_materials": "Outros materiais de vídeo",
    "pass": "Passe",
    "pass_streamer_join_agency_apply": "Adotar o pedido de adesão de âncora",
    "reject_streamer_join_agency_apply": "Rejeitado pedido de adesão de âncora",
    "agree_streamer_join_agency": "Concordar com a âncora {msg_ss1} para se tornar uma âncora abaixo de {msg_ss2}~",
    "reject_streamer_join_agency": "Rejeitando o pedido do membro {msg_ss1} para se tornar membro do {msg_ss2}!",
    "img_material": "Material fotográfico",
    "approver": "Aprovador",
    'user_enter_bind_phone': 'Por favor, digite o número do celular.',
    'vericode': 'Código de verificação',
    'input_vericode': 'Por favor insira o código de verificação',
    'login': 'Conecte-se',
    'reg': 'Registrado',
    'logout': 'Sair',
    'search_for': 'Pesquisar',
    'subscription_closed': 'Encerrado',
    'agency_ID': 'Código da guilda:',
    'reset': 'Redefinir com',
    'live_ID': 'ID de Âncora',
    'live_record': 'Gravação de transmissão ao vivo',
    'email': 'E-mail',
    'phone': 'Telefone',
    'mastery_lang': 'Linguá dominada',
    'to': 'Para',
    'cancel': 'Abolir',
    'Confirm': 'OK',
    'preview': 'Visualizar',
    'rejected': 'Rejeitado',
    'tip': 'Prompt',
    'i_got_it': 'Entendi',
    'cancelled': 'Cancelado',
    'refused': 'Recusar',
    'agency_agree': 'A agência concordou',
    'platform_agree': 'A plataforma concordou',
    'user_not_exist': 'O usuário não existe',
    'user_frozen': 'O usuário foi congelado',
    'reviewing': 'Em revisão',
    'review_pass': 'Revisão aprovada',
    'review_failed': 'Auditoria falhou',
    'xx_hours': '{msg_ss} hora',
    'xx_days': '{msg_ss} dia',
    'xx_hour': '{msg_ss} hora',
    'xx_day': '{msg_ss} dia',
    'xx_year': '{msg_ss} ano',
    'xx_years': '{msg_ss} anos',
    'check_phone_istrue': 'Favor verificar se o número do celular está correto',
    'male': 'Masculino',
    'female': 'Feminino',
    'avatar': 'Retrato',
    'normal': 'Normal',
    'live_room': 'Sala de estar',
    'view': 'Ver',
    'oper_success': 'Operação bem sucedida',
    'copy_success': 'Cópia bem sucedida',
    'new_mobile_already_reg': 'Novo número de celular foi registrado',
    'general_user': 'Usuário Geral',

    'copy': 'Copiar',
    'gender': 'Gênero',
    'submit': 'Enviar',
    'permanent': 'Permanente',
    'agree_agreement': 'Aceite e cumpra o contrato',
    'vericode_error': 'O código de verificação está errado',
    'resend': 'Reenviar',
    'approved': 'Aprovado',
    'not_approved': 'Sem sucesso',
    'agency_rejected': 'A plataforma recusou',
    'select': 'Selecionar',
    'search': 'Pesquisar',
    'rejection_reason': 'Motivo da rejeição',
    'no_data': 'Sem dados',
    'oper_failed': 'Operação fracassada',
    'leave_agency_apply': 'Aprovação de sair agência',
    'over_word_limit': 'Já excedeu o máximo das palavras',
    'delete': 'Deletar',
    'nickname': 'Apelido',
    'file_is_too_large': 'Arquivo muito grande',

    'community_convention': 'Convenção Comunitária de Buzzcast',
    'approval_time': 'Tempo de processamento',
    'guild_system_title': 'Sistema de guilda da plataforma social BuzzCast',
    'return': 'Retorna',
    'img_upload_fail': 'Falha no carragamento da imagem',
    'cooper_ing': 'Em cooperação',
    'upload_file_format_incorrect': 'O arquivo enviado não está no formato correto',
    'token_invalid': 'O token é inválido, faça login novamente!',
    'network_busy': 'A rede está ocupada, tente novamente',
    'minute': '{msg_ss}minuto',

    'live_room_ID': 'ID da sala ao vivo',
    'scan_code': 'Código de verificação do aplicativo BuzzCast para fazer login',
    'open_code': 'Abra o BuzzCastApp, clique no meu código QR para digitalizar',
    'refresh': 'Atualizar',
    'login_confirm': 'Confirmação de login',
    'account': 'Informação da conta',
    'user_name': 'Nome de usuário',
    'edit': 'Modificar',
    'changing': 'Modificar o número ligado de telefone',
    'mobile_number': 'Conta de telefone',
    'mobile_login': 'Você pode fazer login com seu número de telefone {msg_ss}',
    'appId_login': 'Você pode usar a conta cujo AppID é [{msg_ss}] para verificar e fazer login',
    'code_login': 'BuzzCastAppID não está vinculado, após a vinculação, você pode usar o código QR para digitalizar o código para fazer login',
    'verification_log': 'O número do telefone  não está vinculado, após a vinculação, você pode usar o número do telefone e o código de verificação para fazer login',
    'binding_success': 'Vinculação bem-sucedida',
    'binding_mobile': 'Vincular o número de telef',
    'edit_name': 'Modificar nome de usuário',
    'binding_alert': 'Lembrete de alteração de ligação',
    'new_appId': 'Use diretamente a nova ligação de código de verificação APPID, o APPID original será substituído diretamente',
    'binding_account': 'Vincular conta BuzzCastApp',
    'anchor_earings': 'Rendimento de âncora',
    'signing_date': 'Data do contrato',
    'statistical_date': 'Data das estatísticas',
    'valid_min': 'Tempo válido total (minutos)',
    'valid_day': 'Dias válidos (dias)',
    'total_revenue': 'Rendimento total',

    'bind': 'Ligação',
    'please_agree_agree': 'Por favor, concorde com o contrato',
    'note': 'Nota: Todos os tempos mostrados neste sistema é a hora de Nova York, EUA (EST)',
    'app_phone': 'Registre o número do celular do APP',
    'host_num': 'Número de host',
    'enter_host_num': 'Por favor, insira o número de todos os hosts',
    'platform': 'Plataforma de cooperação',
    'statement': 'Extrato bancário mensal',
    'enter_income': 'Insira a renda média mensal',
    'check_commas': 'Formato incorreto. Verifique se as várias plataformas estão separadas por vírgulas',
    'submit_success': 'Seu documento foi enviado com sucesso! vamos lidar com isso o mais rápido possível',
    'usd': 'Dólares',
    'many_platforms': 'Insira a plataforma de transmissão ao vivo com a qual você cooperou antes, até 20 plataformas',
    'limit_platform': 'Até 20 plataformas',
    'user_has_delete': 'Esta conta foi cancelada',
    'cant_commit': 'Você já é uma âncora contratada e não pode pedir para uma agência ao mesmo tempo',
    'cant_commit_1': 'Vocêjá está pedindo a uma âncora contratada, e não pode solicitar uma agência ao mesmo tempo',
    'passwd': 'Senha',
    'passwd_placeholder': 'Sua senha deve conter de 6 a 20 caracteres',
    'live_rights': 'Avaliação sem tempo',
    'edit_log': 'Alterar registro',
    'edit_time': 'Modifique o tempo',
    'edit_pwd': 'Alterar a senha',
    'old_pwd': 'Senha Antiga',
    'new_pwd': 'Nova Senha',
    'confirm_pwd': 'Confirme a senha',
    'forget_pwd': 'Esqueceu a senha?',
    'email_check': 'Formato de e-mail incorreto',
    'phone_pwd_error': 'Número de telefone ou senha incorreta',
    'ten_min_error': 'Por favor, tente novamente em 10 minutos',
    'phone_bind_error': 'O número de telefone celular foi vinculado a outra conta, por favor mude para um novo número de telefone celular para vinculá-lo.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'O ID do líder da guilda já foi preenchido, por favor, preencha novamente',
    'pwd_error': 'Senha incorreta',
    'phone_not_reg_error': 'Conta não registrada',
    'pwd_nq': 'As novas senhas digitadas são inconsistentes',
    'sign_anchor_error': 'Você já é um locutor contratado e não pode se inscrever para uma guilda ao mesmo tempo',
    'apply_anchor_error': 'Você já inscreveu uma emissora contratada e não pode solicitar a instalação de uma guilda ao mesmo tempo',
    'have-expired': 'Expirado ',
    'approval-time': 'Tempo de aprovação',
    'reasons-for-refusal': 'Por favor, digite o motivo de recusa',
    'Transfer-grounds': 'Razão da transferência de agência:',
    'code_expire': 'Código de validação expirado, por favor clique nele para atualizá-lo',
    'transfer-approval': 'Aprovação de transferência',
    'live_state_placeholder': 'Status no vivo',
    'live_state_open': 'Normal',
    'live_state_temporary_banned': 'Banido',
    'live_state_forever_banned': 'Banido permanentemente',
    'live_allowed_time': 'Horário de início permitido',
    'live_banned_time': 'Ciclo de ban',
    'deduct_money': 'Deduzir a quantidade de moedas B',
    'final_income': 'Renda real',
    'select_start_dt': 'Por favor, selecione uma hora de início',
    'select_end_dt': 'Por favor, selecione um horário de término',
    'less_then_end_dt': 'O horário de início deve ser menor ou igual ao horário de término',
    'System_automatically_through': 'O sistema passa automaticamente',
    'btrade_err': 'O ID da agência não está disponível',

    'mouth_anchor': 'Streamer de salário mensal',
    'day_anchor': 'Streamer de salário diário',
    'guild_anchor': 'Recompensa do agente (salário diário)',
    'mouth_anchor_st': 'Hora de início do salário mensal',
    'mouth_anchor_et': 'Hora de término do salário mensal',
    'day_anchor_st': 'Hora de início do salário diário',
    'day_anchor_et': 'Hora de término do salário diário',
    'all_award_bcoin': 'Renda total da recompensa salarial diária',
    'live_hour': 'Recompensa de duração válida de transmissão ao vivo',
    'salary_day': 'Data',
    'day_in_come': 'Renda diária da agência (moedas B)',
    'award_ration_flag_str': 'Proporção de recompensa',
    'payable_money': 'Recompensa de moeda B do agente',
    'host_bcoins': 'Ganhos de Bcoins de Âncora',
    'total_official': 'Recompensa total oficial de Bcoins',
    'actual_bcoins_awarded': 'Recompensa real de Bcoins',
    "change_bound_account":"Alterar conta vinculada" ,
    "agent_id_form":"ID de Agente:" ,
    "BuzzCast_verification_code":"Código de verificação do BuzzCast:" ,
    "send_success":"Enviar sucesso" ,
    "account_changed_successfully":"Conta vinculada alterada com sucesso" ,
    "invite_guild_url":"Link de convite para se tornar um agente do BuzzCast: {msg_ss}" ,
    "invite_guild_code":"Meu código de convite:{msg_ss}" ,
    "save":"Salvar" ,
    "compile":"Editar" ,
    "agent_nvitation_eward":"Recompensa por convidar agentes" ,
    "agent_name":"Apelido do agente" ,
    "guild_id":"Código da agência" ,
    "guild_income_30days":"Receita da agência nos últimos 30 dias" ,
    "guild_invite_income_30days":"Receita de convites de agências nos últimos 30 dias" ,
    "agency_commission_ratio":"Taxa de comissão do agente" ,
    "invite_income_bcoins":"Convite recompensa moedas B" ,
    "id_not_exist": "O ID não existe",
    'reward_distribution_status': 'Estado de distribuição de recompensa',
    'must_number': 'A sua entrada deve estar em formato puramente numérico.',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/pt.js